module.exports = __webpack_public_path__ + "img/5.63c8ed2d.png";